// extracted by mini-css-extract-plugin
export default {"underline":"underline-e7d8","subtitle":"subtitle-ec2b"};